import React from "react";
import { useState, useEffect, useRef } from "react";
import {
    Box, Button, Grid, Typography, TextField, MenuItem, IconButton, InputAdornment, Divider, Avatar, Select, Dialog, DialogContent
} from "@mui/material";
import { CiEdit } from "react-icons/ci";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { FaRegCalendarAlt } from "react-icons/fa";
import ProjectIcon2 from "assets/icons/ProjectIcon2.svg"
import ProjectIcon4 from "assets/icons/ProjectIcon4.svg"
import AeroplaneIcon from "assets/icons/ProjectIcon1.svg"
import HeartIcon from "assets/icons/HeartIcon.svg"
import ProjectIcon3 from "assets/icons/ProjectIcon3.svg"
import { IoIosClose } from "react-icons/io";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useUpdateProjectMutation } from "store/slices/apis/projectApiSlice";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { useDispatch } from "store";
import { useNavigate } from "react-router-dom";
import { state } from "utils/statesData";



const MILLION = 1000000

const EditProject = ({ open, onClose, projectData, setIsEditPopupOpen }) => {

    useEffect(() => {
        if (projectData) {

        }
    }, [projectData]);


    const [openStart, setOpenStart] = useState(false);
    const [updateProject, { isLoading, error }] = useUpdateProjectMutation();
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [openEnd, setOpenEnd] = useState(false)
    const [isEditable, setIsEditable] = useState(false);
    const startDateRef = useRef(null);
    const endDateRef = useRef(null);
    const inputRef = useRef(null);

    const handleStartIconClick = (e) => {
        e.stopPropagation();
        if (startDateRef.current) {
            startDateRef.current.showPicker?.();
            startDateRef.current.focus();
        }
    };

    const handleEndIconClick = (e) => {
        e.stopPropagation();
        if (endDateRef.current) {
            endDateRef.current.showPicker?.();
            endDateRef.current.focus();
        }
    };


    const handleEditClick = () => {
        setIsEditable(!isEditable);
        setTimeout(() => {
            inputRef.current?.focus();
        }, 0);
    };

    const projectStatus = [
        "ONGOING", "COMPLETED"
    ]

    const phoneCodes = ["+91", "+1", "+44", "+61", "+81", "+49", "+33", "+39", "+86", "+971"];

    const projectTypes = [
        "FOURWRD",
        "FOURCI",
        "FOURUN",
        "WAY - SIDE AMENITIES",
    ];

    const country = [
        "India",
    ];

    // const state = [
    //     // 🇮🇳 Indian States
    //     "Maharashtra",
    //     "Karnataka",
    //     "Tamil Nadu",
    //     "Uttar Pradesh",
    //     "Gujarat",
    //     "West Bengal",
    //     "Rajasthan",
    //     "Delhi",
    //     "Madhya Pradesh"
    // ];


    const iconList = [
        { name: "ProjectIcon2", src: ProjectIcon2 },
        { name: "ProjectIcon4", src: ProjectIcon4 },
        { name: "AeroplaneIcon", src: AeroplaneIcon },
        { name: "HeartIcon", src: HeartIcon },
        { name: "ProjectIcon3", src: ProjectIcon3 },
    ];


    const openNotification = (msg, type = "error", duration = 6000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: "alert",
                alert: { color: type, variant: "filled" },
                transition: "SlideUp",
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const handlSubmitForm = async (values) => {
        const formData = new FormData();


        const convertToISO = (dateValue) => {
            if (!dateValue) return "";
            if (dateValue instanceof Date) {
                return dateValue.toISOString();
            }
            if (typeof dateValue === "string") {
                if (dateValue.includes("T")) return new Date(dateValue).toISOString();
                return new Date(dateValue + "T00:00:00.000Z").toISOString();
            }
            return "";
        };

        formData.append("ProjectName", values.projectName || "");
        formData.append("ProjectType", values.projectType || "");
        formData.append("Description", values.description || "");
        formData.append("ClientBusinessName", values.client_business_name || "");
        formData.append("ContractorBusinessName", values.contractor_business_name || "");
        formData.append("ContractorNumber", values.contractor_number || "");
        formData.append("AddressLine1", values.address_line_1 || "");
        formData.append("AddressLine2", "");
        formData.append("City", values.city || "");
        formData.append("State", values.state || "");
        formData.append("Country", values.country || "");
        formData.append("ZipCode", values.zipcode || "");
        formData.append("CurrencyBudget", values.currency_budget || "INR");
        formData.append("BudgetedCost", values.budgeted_cost || "");
        formData.append("ProjectManagerName", values.project_manager_name || "");
        formData.append("ProjectManagerEmail", values.project_manager_email || "");
        formData.append("ProjectManagerPhoneNo", values.project_manager_phoneno || "");
        formData.append("CountryCode", values.country_code || "+91");
        formData.append("AwardedCost", values.awarded_cost || "");
        formData.append("CurrencyAwarded", values.currency_awarded || "INR");
        formData.append("Latitude", values.latitude || "");
        formData.append("Longitude", values.longitude || "");
        formData.append("StartDate", convertToISO(values.start_date));
        formData.append("EndDate", convertToISO(values.end_date));
        formData.append("ProjectManagerDesignation", values.project_manager_designation || "");
        formData.append("Status", values.projectStatus);
        formData.append("TotalLand", values.TotalLand || "");
        formData.append("BuiltUpArea", values.BuiltUpArea || "");
        formData.append("DelieveredArea", values.DelieveredArea || "");
        formData.append("LeasingPercentage", values.LeasingPercentage || "");
        formData.append("OriginalBudget", values.original_budgeted_cost || "");
        formData.append("OriginalBudgetCurrency", values.currency_original_budget || "INR");

        if (values.projectIcon) {
            formData.append("ProjectIcon", values.projectIcon);
        }
        const projectId = projectData.projectId;


        try {
            const res = await updateProject({ projectId, project: formData }).unwrap();

            if (res.status === 'Success') {

                openNotification(res.message, "success");
                setIsEditPopupOpen(false)
                navigate("/project-list");
            } else {

                openNotification(res.message || "Something went wrong while creating the project.", "error");
            }
        } catch (err) {
            console.error("Error creating project:", err);

            openNotification(err?.data?.message || "Failed to create project. Please try again.", "error");
        }

    };

    const selectedIcon = iconList.find(icon => icon.name === projectData?.projectIcon) || iconList[0].name


    const [projectIcon, setIconComponent] = useState(iconList[0])
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            projectName: projectData?.projectName || "",
            projectType: projectData?.projectType || "",
            projectIcon: selectedIcon.name || iconList[0].name,
            description: projectData?.description || "",
            start_date: projectData?.startDate ? dayjs(projectData.startDate).format() : "",
            end_date: projectData?.endDate ? dayjs(projectData.endDate).format() : "",
            address_line_1: projectData?.addressLine1 || "",
            city: projectData?.city || "",
            state: projectData?.state || "",
            country: projectData?.country || "",
            zipcode: projectData?.zipCode || "",
            latitude: projectData?.latitude || "",
            longitude: projectData?.longitude || "",
            client_business_name: projectData?.clientBusinessName || "",
            contractor_business_name: projectData?.contractorBusinessName || "",
            contractor_number: projectData?.contractorNumber || "",
            currency_budget: projectData?.currencyBudget || "INR",
            budgeted_cost: projectData?.budgetedCost || "",
            currency_awarded: projectData?.currencyAwarded || "INR",
            awarded_cost: projectData?.awardedCost || "",
            project_manager_name: projectData?.projectManagerName || "",
            project_manager_designation: projectData?.projectManagerDesignation || "",
            project_manager_email: projectData?.projectManagerEmail || "",
            country_code: projectData?.countryCode || "+91",
            project_manager_phoneno: projectData?.projectManagerPhoneNo || "",
            projectStatus: projectData?.status,
            TotalLand: projectData?.totalLand * MILLION || "",
            BuiltUpArea: projectData?.builtUpArea * MILLION || "",
            DelieveredArea: projectData?.delieveredArea * MILLION || "",
            LeasingPercentage: projectData?.leasingPercentage || "",
            currency_original_budget: projectData?.originalBudgetCurrency || "INR",
            original_budgeted_cost: projectData?.originalBudget || "",
        },

        validationSchema: Yup.object({
            projectName: Yup.string().required("Project name is required").max(100, "Project name must be at most 100 characters"),
            projectType: Yup.string().required("Project type is required"),
            projectIcon: Yup.string()
                .required("Project Icon is required")
                .max(100, "Project Icon must be at most 100 characters"),
            projectStatus: Yup.string()
                .required("Project Status is required"),
            description: Yup.string().required("Description is required").max(500, "Description can't exceed 500 characters"),
            start_date: Yup.date().required("Start date is required").typeError("Start date must be a valid date"),
            end_date: Yup.date().required("End date is required").typeError("End date must be a valid date").min(Yup.ref("start_date"), "End date cannot be before start date"),
            address_line_1: Yup.string().required("Address line 1 is required"),
            city: Yup.string().required("City is required"),
            state: Yup.string().required("State is required"),
            country: Yup.string().required("Country is required"),
            zipcode: Yup.string().required("Zipcode is required").matches(/^[0-9]{5,6}$/, "Zipcode must be 5 or 6 digits"),
            latitude: Yup.string().required("Latitude  required").matches(/^[-+]?[0-9]*\.?[0-9]+$/, "Latitude must be a valid number"),
            longitude: Yup.string().required("Longitude required").matches(/^[-+]?[0-9]*\.?[0-9]+$/, "Longitude must be a valid number"),
            client_business_name: Yup.string().required("Client business name is required"),
            contractor_business_name: Yup.string().required("Contractor business name is required"),
            contractor_number: Yup.string().required("Contractor number is required").matches(/^[0-9]{10}$/, "Contractor number must be 10 digits"),
            budgeted_cost: Yup.number().typeError("Budgeted cost must be a number").required("Budgeted cost is required").positive("Budgeted cost must be positive"),
            awarded_cost: Yup.number().typeError("Awarded cost must be a number").required("Awarded cost is required").positive("Awarded cost must be positive"),
            project_manager_name: Yup.string().required("Project manager name is required"),
            project_manager_designation: Yup.string().required("Project manager designation is required"),
            project_manager_email: Yup.string().email("Invalid email format").required("Project manager email is required"),
            project_manager_phoneno: Yup.string().required("Project manager phone number is required").matches(/^[0-9]{10}$/, "Phone number must be 10 digits"),
            original_budgeted_cost: Yup.number().typeError("Original Budgeted cost must be a number").required("Original Budgeted cost is required").positive("Original Budgeted cost must be positive"),
        }),

        onSubmit: async (values, formikHelpers) => {
            handlSubmitForm(values)
            formikHelpers.resetForm()
        },
    });

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            fullWidth
            sx={{
                "& .MuiDialog-paper": {
                    borderRadius: "8px",
                    margin: "0px",
                    width: "95%",
                    maxWidth: "100%",
                    height: "95%",
                    maxHeight: "100%",
                }
            }}
        >
            <DialogContent sx={{
                p: 0,
                overflow: "auto",
                '&.MuiDialogContent-root': {
                    padding: 0
                }
            }}>
                <Box
                    component="form"
                    onSubmit={(e) => {
                        e.preventDefault();
                        formik.handleSubmit(e);
                    }}
                    sx={{ minHeight: "100vh", p: { xs: "10px", md: "40px" } }}>
                    <Grid container>
                        <Grid size={12}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "88px",
                                        height: "18px",
                                        alignItems: "center",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: "18px",
                                            height: "18px",
                                            borderRadius: "4px",
                                            backgroundColor: "#ECECEC",
                                        }}
                                    >
                                        <CiEdit size={11} />
                                    </Box>
                                    <Typography
                                        sx={{
                                            fontSize: "12px",
                                            fontWeight: 400,
                                            lineHeight: "100%",
                                            color: "#5B5772",
                                            fontFamily: "Outfit, sans-serif"
                                        }}
                                    >
                                        Edit Project
                                    </Typography>
                                </Box>

                                <Button
                                    onClick={onClose}
                                    sx={{
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        lineHeight: "24px",
                                        height: "32px",
                                        width: "73px",
                                        color: "#FF5F57",
                                        fontFamily: "Outfit, sans-serif",
                                        backgroundColor: "#FF383C33",
                                        borderRadius: "6px",
                                        textTransform: "none",
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>

                    {/* Below Section (Two Columns) */}
                    <Grid
                        container
                        columnSpacing={3}
                        rowSpacing={3}
                        sx={{ mt: "15px" }}
                    >
                        {/* Left Column */}
                        <Grid size={{ xs: 12, md: 7 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                    p: 0,
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "10px",
                                        p: 0,
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: "16px",
                                            fontWeight: 500,
                                            color: "#2C274A",
                                            fontFamily: "Outfit, sans-serif"
                                        }}
                                    >
                                        Project Name
                                    </Typography>
                                    <TextField
                                        variant="standard"
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                        sx={{
                                            "& .MuiInput-root": {
                                                backgroundColor: "transparent",
                                                padding: 0,
                                            },
                                            "& .MuiInput-input": {
                                                fontSize: "54px",
                                                fontWeight: 600,
                                                color: "#2C274A",
                                                fontFamily: "Outfit, sans-serif",
                                                padding: 0,
                                                margin: 0,

                                                cursor: "text",

                                                "&::selection": {
                                                    backgroundColor: "rgba(0, 52, 76, 0.2)",
                                                },
                                            },
                                        }}
                                        name="projectName"
                                        value={formik.values.projectName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        placeholder="Project Name"
                                        error={formik.touched.projectName && Boolean(formik.errors.projectName)}
                                        helperText={formik.touched.projectName && formik.errors.projectName}
                                    />
                                </Box>

                                {/* Edit Form Start */}
                                <Box
                                    sx={{
                                        mt: "20px",
                                        height: "137px",
                                        backgroundColor: "#ECECEC",
                                        borderRadius: "6px",
                                        p: "10px 20px",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: 500,
                                            fontSize: "16px",
                                            fontFamily: "Outfit, sans-serif",
                                            color: "#2C274A",
                                        }}
                                    >
                                        Project Description
                                    </Typography>
                                    <TextField
                                        placeholder="Add a description"
                                        fullWidth
                                        multiline
                                        minRows={4}
                                        variant="standard"
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                        sx={{
                                            mt: "14px",
                                            "& .MuiInput-root": {
                                                borderRadius: "8px",
                                                display: "flex",
                                                alignItems: "flex-start",
                                            },
                                            "& .MuiInput-input": {
                                                fontFamily: "Outfit, sans-serif",
                                                color: "#0A0A0C",
                                                textAlign: "start",
                                                padding: 0,
                                                "&:-webkit-autofill": {
                                                    WebkitBoxShadow: "0 0 0 100px #ECECEC inset !important",
                                                    WebkitTextFillColor: "#0A0A0C !important",
                                                },
                                                "&:-webkit-autofill:hover": {
                                                    WebkitBoxShadow: "0 0 0 100px #ECECEC inset !important",
                                                },
                                                "&:-webkit-autofill:focus": {
                                                    WebkitBoxShadow: "0 0 0 100px #ECECEC inset !important",
                                                },
                                            },
                                        }}
                                        name="description"
                                        value={formik.values.description}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}

                                    />
                                </Box>
                                {formik.touched.description && formik.errors.description && (
                                    <Typography sx={{ color: "#D92D20", fontSize: "12px", }}>
                                        {formik.errors.description}
                                    </Typography>
                                )}
                                <Box sx={{ mt: "20px", display: "flex", flexDirection: "column", gap: "15px", width: { xs: "auto", md: "520px" } }}>
                                    <Box sx={{ display: "flex", gap: "15px", alignItems: "flex-start", width: "100%" }}>
                                        {/* Project Type */}
                                        <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", flex: 1 }}>
                                            <Typography
                                                sx={{
                                                    fontWeight: 500,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",  // ✅ Consistent lineHeight
                                                    fontFamily: "Outfit, sans-serif",
                                                    color: "#5F5F5F",
                                                    height: "16px", // ✅ Fixed height for consistent alignment
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                Project type
                                            </Typography>
                                            <Box sx={{ position: "relative", width: "100%" }}>
                                                <Select
                                                    displayEmpty
                                                    value={formik.values.projectType}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    name="projectType"
                                                    sx={{
                                                        width: "100%",
                                                        height: 44,
                                                        backgroundColor: "#E7E7EB",
                                                        borderRadius: "6px",
                                                        "& .MuiOutlinedInput-notchedOutline": {
                                                            border: "1px solid #ECECEC",
                                                        },
                                                        "& .MuiSelect-select": {
                                                            px: 2,
                                                            fontSize: 16,
                                                            fontWeight: 400,
                                                            fontFamily: "Outfit, sans-serif",
                                                            color: "#3F3F3F",
                                                            display: "flex",
                                                            alignItems: "center", // ✅ Consistent alignment
                                                            height: "100%",
                                                        },
                                                    }}
                                                >
                                                    <MenuItem value="" disabled>
                                                        Select Project Type
                                                    </MenuItem>
                                                    {projectTypes.map((type, index) => (
                                                        <MenuItem key={index} value={type}>
                                                            {type}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Box>
                                            {formik.touched.projectType && formik.errors.projectType && (
                                                <Typography sx={{ color: "#D92D20", fontSize: "12px", ml: 1 }}>
                                                    {formik.errors.projectType}
                                                </Typography>
                                            )}
                                        </Box>

                                        {/* Project Status */}
                                        <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", flex: 1 }}>
                                            <Typography
                                                sx={{
                                                    fontWeight: 500,
                                                    fontSize: "16px",
                                                    fontFamily: "Outfit, sans-serif",
                                                    color: "#5F5F5F",
                                                    lineHeight: "100%", // ✅ Same lineHeight
                                                    height: "16px", // ✅ Same fixed height
                                                    display: "flex",
                                                    alignItems: "center" // ✅ Same alignment
                                                }}
                                            >
                                                Project Status
                                            </Typography>
                                            <Box sx={{ width: "100%" }}>
                                                <Select
                                                    displayEmpty
                                                    name="projectStatus"
                                                    value={formik.values.projectStatus}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.projectStatus && Boolean(formik.errors.projectStatus)}
                                                    sx={{
                                                        width: "100%",
                                                        height: 44,
                                                        backgroundColor: "#FFFFFF",
                                                        borderRadius: "6px",
                                                        "& .MuiOutlinedInput-notchedOutline": {
                                                            border: "1px solid #ECECEC",
                                                        },
                                                        "& .MuiSelect-select": {
                                                            px: 2,
                                                            fontSize: "16px",
                                                            fontWeight: 400,
                                                            color: "#0A0A0C",
                                                            letterSpacing: "1%",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            fontFamily: "Outfit, sans-serif"
                                                        }
                                                    }}
                                                >
                                                    <MenuItem value="" disabled>
                                                        Select Status
                                                    </MenuItem>
                                                    {projectStatus.map((type, index) => (
                                                        <MenuItem key={index} value={type}>
                                                            {type}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Box>
                                            {formik.touched.projectStatus && formik.errors.projectStatus && (
                                                <Typography sx={{ color: "#D92D20", fontSize: "12px", ml: 1 }}>
                                                    {formik.errors.projectStatus}
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>

                                    <Box sx={{ display: "flex", gap: "15px", alignItems: "flex-start", width: "100%" }}>
                                        <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", flex: 1 }}>
                                            <Typography
                                                sx={{
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    fontFamily: "Outfit, sans-serif",
                                                    color: "#414143",
                                                }}
                                            >
                                                Total Land
                                            </Typography>
                                            <TextField
                                                placeholder="Total Land"
                                                fullWidth
                                                variant="standard"
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                                sx={{

                                                    "& .MuiInput-root": {
                                                        borderRadius: "8px",
                                                        backgroundColor: "#FFFFFF",
                                                        height: 44,
                                                        px: 2,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        border: "1px solid #ECECEC"
                                                    },
                                                    "& .MuiInput-input": {
                                                        fontFamily: "Outfit, sans-serif",
                                                        padding: 0,
                                                        color: "#0A0A0C",
                                                        fontSize: "16px",
                                                        fontWeight: 400,
                                                        lineHeight: "100%",
                                                        "&:-webkit-autofill": {
                                                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                            WebkitTextFillColor: "#0A0A0C !important",
                                                        },
                                                        "&:-webkit-autofill:hover": {
                                                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                        },
                                                        "&:-webkit-autofill:focus": {
                                                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                        },
                                                    },
                                                }}
                                                name="TotalLand"
                                                value={formik.values.TotalLand}
                                                onChange={formik.handleChange}
                                            />
                                        </Box>

                                        <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", flex: 1 }}>
                                            <Typography
                                                sx={{
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    fontFamily: "Outfit, sans-serif",
                                                    color: "#414143",
                                                }}
                                            >
                                                Built Up Area
                                            </Typography>
                                            <TextField
                                                placeholder="Built Up Area"
                                                fullWidth
                                                variant="standard"
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                                sx={{

                                                    "& .MuiInput-root": {
                                                        borderRadius: "8px",
                                                        backgroundColor: "#FFFFFF",
                                                        height: 44,
                                                        px: 2,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        border: "1px solid #ECECEC"
                                                    },
                                                    "& .MuiInput-input": {
                                                        fontFamily: "Outfit, sans-serif",
                                                        padding: 0,
                                                        color: "#0A0A0C",
                                                        fontSize: "16px",
                                                        fontWeight: 400,
                                                        lineHeight: "100%",
                                                        "&:-webkit-autofill": {
                                                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                            WebkitTextFillColor: "#0A0A0C !important",
                                                        },
                                                        "&:-webkit-autofill:hover": {
                                                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                        },
                                                        "&:-webkit-autofill:focus": {
                                                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                        },
                                                    },
                                                }}
                                                name="BuiltUpArea"
                                                value={formik.values.BuiltUpArea}
                                                onChange={formik.handleChange}
                                            />
                                        </Box>
                                    </Box>

                                    <Box sx={{ display: "flex", gap: "15px", alignItems: "flex-start", width: "100%" }}>
                                        <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", flex: 1 }}>
                                            <Typography
                                                sx={{
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    fontFamily: "Outfit, sans-serif",
                                                    color: "#414143",
                                                }}
                                            >
                                                Delievered Area
                                            </Typography>
                                            <TextField
                                                placeholder="Delievered Area"
                                                fullWidth
                                                variant="standard"
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                                sx={{

                                                    "& .MuiInput-root": {
                                                        borderRadius: "8px",
                                                        backgroundColor: "#FFFFFF",
                                                        height: 44,
                                                        px: 2,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        border: "1px solid #ECECEC"
                                                    },
                                                    "& .MuiInput-input": {
                                                        fontFamily: "Outfit, sans-serif",
                                                        padding: 0,
                                                        color: "#0A0A0C",
                                                        fontSize: "16px",
                                                        fontWeight: 400,
                                                        lineHeight: "100%",
                                                        "&:-webkit-autofill": {
                                                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                            WebkitTextFillColor: "#0A0A0C !important",
                                                        },
                                                        "&:-webkit-autofill:hover": {
                                                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                        },
                                                        "&:-webkit-autofill:focus": {
                                                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                        },
                                                    },
                                                }}
                                                name="DelieveredArea"
                                                value={formik.values.DelieveredArea}
                                                onChange={formik.handleChange}
                                            />
                                        </Box>

                                        <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", flex: 1 }}>
                                            <Typography
                                                sx={{
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    fontFamily: "Outfit, sans-serif",
                                                    color: "#414143",
                                                }}
                                            >
                                                Leasing Percentage
                                            </Typography>
                                            <TextField
                                                placeholder="Leasing Percentage"
                                                fullWidth
                                                variant="standard"
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                                sx={{

                                                    "& .MuiInput-root": {
                                                        borderRadius: "8px",
                                                        backgroundColor: "#FFFFFF",
                                                        height: 44,
                                                        px: 2,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        border: "1px solid #ECECEC"
                                                    },
                                                    "& .MuiInput-input": {
                                                        fontFamily: "Outfit, sans-serif",
                                                        padding: 0,
                                                        color: "#0A0A0C",
                                                        fontSize: "16px",
                                                        fontWeight: 400,
                                                        lineHeight: "100%",
                                                        "&:-webkit-autofill": {
                                                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                            WebkitTextFillColor: "#0A0A0C !important",
                                                        },
                                                        "&:-webkit-autofill:hover": {
                                                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                        },
                                                        "&:-webkit-autofill:focus": {
                                                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                        },
                                                    },
                                                }}
                                                name="LeasingPercentage"
                                                value={formik.values.LeasingPercentage}
                                                onChange={formik.handleChange}
                                            />
                                        </Box>
                                    </Box>

                                    <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", }}>
                                        <Typography
                                            sx={{
                                                fontWeight: 400,
                                                fontSize: "16px",
                                                lineHeight: "100%",
                                                fontFamily: "Outfit, sans-serif",
                                                color: "#414143",
                                            }}
                                        >
                                            Client Business Name{" "}
                                            <Box component="span" sx={{ color: "#D92D20" }}>
                                                *
                                            </Box>
                                        </Typography>
                                        <TextField
                                            placeholder="Client Business Name"
                                            fullWidth
                                            variant="standard"
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                            sx={{

                                                "& .MuiInput-root": {
                                                    borderRadius: "8px",
                                                    backgroundColor: "#FFFFFF",
                                                    height: 44,
                                                    px: 2,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    border: "1px solid #ECECEC"
                                                },
                                                "& .MuiInput-input": {
                                                    fontFamily: "Outfit, sans-serif",
                                                    padding: 0,
                                                    color: "#0A0A0C",
                                                    fontSize: "16px",
                                                    fontWeight: 400,
                                                    lineHeight: "100%",
                                                    "&:-webkit-autofill": {
                                                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                        WebkitTextFillColor: "#0A0A0C !important",
                                                    },
                                                    "&:-webkit-autofill:hover": {
                                                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                    },
                                                    "&:-webkit-autofill:focus": {
                                                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                    },
                                                },
                                            }}
                                            name="client_business_name"
                                            value={formik.values.client_business_name}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.client_business_name && Boolean(formik.errors.client_business_name)}
                                            helperText={formik.touched.client_business_name && formik.errors.client_business_name}
                                        />

                                    </Box>
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", }}>
                                        <Typography
                                            sx={{
                                                fontWeight: 400,
                                                fontSize: "16px",
                                                lineHeight: "100%",
                                                fontFamily: "Outfit, sans-serif",
                                                color: "#414143",
                                            }}
                                        >
                                            Contractor Business Name{" "}
                                            <Box component="span" sx={{ color: "#D92D20" }}>
                                                *
                                            </Box>
                                        </Typography>
                                        <TextField
                                            placeholder="Contractor Business Name"
                                            fullWidth
                                            variant="standard"
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                            sx={{

                                                "& .MuiInput-root": {
                                                    borderRadius: "8px",
                                                    backgroundColor: "#FFFFFF",
                                                    height: 44,
                                                    px: 2,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    border: "1px solid #ECECEC"
                                                },
                                                "& .MuiInput-input": {
                                                    fontFamily: "Outfit, sans-serif",
                                                    padding: 0,
                                                    color: "#0A0A0C",
                                                    fontSize: "16px",
                                                    fontWeight: 400,
                                                    lineHeight: "100%",
                                                    "&:-webkit-autofill": {
                                                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                        WebkitTextFillColor: "#0A0A0C !important",
                                                    },
                                                    "&:-webkit-autofill:hover": {
                                                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                    },
                                                    "&:-webkit-autofill:focus": {
                                                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                    },
                                                },
                                            }}
                                            name="contractor_business_name"
                                            value={formik.values.contractor_business_name}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.contractor_business_name && Boolean(formik.errors.contractor_business_name)}
                                            helperText={formik.touched.contractor_business_name && formik.errors.contractor_business_name}
                                        />

                                    </Box>
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", }}>
                                        <Typography
                                            sx={{
                                                fontWeight: 400,
                                                fontSize: "16px",
                                                lineHeight: "100%",
                                                fontFamily: "Outfit, sans-serif",
                                                color: "#414143",
                                            }}
                                        >
                                            Contractor Number{" "}
                                            <Box component="span" sx={{ color: "#D92D20" }}>
                                                *
                                            </Box>
                                        </Typography>
                                        <TextField
                                            placeholder="Contractor Number"

                                            variant="standard"
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                            sx={{

                                                "& .MuiInput-root": {
                                                    borderRadius: "8px",
                                                    backgroundColor: "#FFFFFF",
                                                    height: 44,
                                                    width: { xs: "auto", md: 334 },
                                                    px: 2,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    border: "1px solid #ECECEC"
                                                },
                                                "& .MuiInput-input": {
                                                    fontFamily: "Outfit, sans-serif",
                                                    padding: 0,
                                                    color: "#0A0A0C",
                                                    fontSize: "16px",
                                                    fontWeight: 400,
                                                    lineHeight: "100%", "&:-webkit-autofill": {
                                                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                        WebkitTextFillColor: "#0A0A0C !important",
                                                    },
                                                    "&:-webkit-autofill:hover": {
                                                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                    },
                                                    "&:-webkit-autofill:focus": {
                                                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                    },
                                                },
                                            }}
                                            name="contractor_number"
                                            value={formik.values.contractor_number}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.contractor_number && Boolean(formik.errors.contractor_number)}
                                            helperText={formik.touched.contractor_number && formik.errors.contractor_number}
                                        />

                                    </Box>
                                </Box>
                                <Box sx={{ mt: "20px", display: "flex", flexDirection: "column", width: { xs: "auto", md: "520px" } }}>
                                    <Box sx={{ mt: "0px" }}>
                                        <Typography
                                            sx={{
                                                fontWeight: 500,
                                                fontSize: "16px",
                                                fontFamily: "Outfit, sans-serif",
                                                color: "#5F5F5F",
                                            }}
                                        >
                                            Project Address{" "}
                                            <Box component="span" sx={{ color: "#D92D20" }}>
                                                *
                                            </Box>
                                            <Grid container rowSpacing={1.4} columnSpacing={1}>
                                                <Grid size={12}>
                                                    <TextField
                                                        placeholder="Address Line 1"
                                                        fullWidth
                                                        variant="standard"
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                        sx={{
                                                            mt: "9px",
                                                            "& .MuiInput-root": {
                                                                borderRadius: "8px",
                                                                backgroundColor: "#FFFFFF",
                                                                height: 44,
                                                                px: 2,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                border: "1px solid #ECECEC"
                                                            },
                                                            "& .MuiInput-input": {
                                                                fontFamily: "Outfit, sans-serif",
                                                                padding: 0,
                                                                color: "#0A0A0C",
                                                                fontSize: "16px",
                                                                fontWeight: 400,
                                                                lineHeight: "100%",
                                                                "&:-webkit-autofill": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                    WebkitTextFillColor: "#0A0A0C !important",
                                                                },
                                                                "&:-webkit-autofill:hover": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                },
                                                                "&:-webkit-autofill:focus": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                },
                                                            },
                                                        }}
                                                        name="address_line_1"
                                                        value={formik.values.address_line_1}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.address_line_1 && Boolean(formik.errors.address_line_1)}
                                                        helperText={formik.touched.address_line_1 && formik.errors.address_line_1}
                                                    />
                                                </Grid>

                                                <Grid size={6}>
                                                    <Select
                                                        displayEmpty
                                                        value={formik.values.state}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        name="state"
                                                        fullWidth
                                                        sx={{
                                                            height: 44,
                                                            backgroundColor: "#FFFFFF",
                                                            borderRadius: "6px",
                                                            "& .MuiOutlinedInput-notchedOutline": {
                                                                border: "1px solid #ECECEC",
                                                            },
                                                            "& .MuiSelect-select": {
                                                                px: 2,
                                                                fontSize: 16,
                                                                fontWeight: 400,
                                                                fontFamily: "Outfit, sans-serif",
                                                                color: "#3F3F3F",
                                                                lineHeight: "100%"
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem value="" disabled>
                                                            State
                                                        </MenuItem>
                                                        {state.map((type, index) => (
                                                            <MenuItem key={index} value={type}>
                                                                {type}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </Grid>

                                                <Grid size={6}>
                                                    <TextField
                                                        placeholder="City"
                                                        fullWidth
                                                        variant="standard"
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                        sx={{

                                                            "& .MuiInput-root": {
                                                                borderRadius: "8px",
                                                                backgroundColor: "#FFFFFF",
                                                                height: 44,
                                                                px: 2,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                border: "1px solid #ECECEC"
                                                            },
                                                            "& .MuiInput-input": {
                                                                fontSize: 16,
                                                                fontWeight: 400,
                                                                fontFamily: "Outfit, sans-serif",
                                                                color: "#3F3F3F",
                                                                lineHeight: "100%",
                                                                "&:-webkit-autofill": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                    WebkitTextFillColor: "#3F3F3F !important",
                                                                },
                                                                "&:-webkit-autofill:hover": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                },
                                                                "&:-webkit-autofill:focus": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                },
                                                            },
                                                        }}
                                                        name="city"
                                                        value={formik.values.city}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.city && Boolean(formik.errors.city)}
                                                        helperText={formik.touched.city && formik.errors.city}
                                                    />
                                                </Grid>
                                                <Grid size={6}>
                                                    <Select
                                                        displayEmpty
                                                        fullWidth
                                                        sx={{
                                                            height: 44,
                                                            backgroundColor: "#FFFFFF",
                                                            borderRadius: "6px",
                                                            "& .MuiOutlinedInput-notchedOutline": {
                                                                border: "1px solid #ECECEC",
                                                            },
                                                            "& .MuiSelect-select": {
                                                                px: 2,
                                                                fontSize: 16,
                                                                fontWeight: 400,
                                                                fontFamily: "Outfit, sans-serif",
                                                                color: "#3F3F3F",
                                                                lineHeight: "100%",
                                                                "&:-webkit-autofill": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                    WebkitTextFillColor: "#3F3F3F !important",
                                                                },
                                                                "&:-webkit-autofill:hover": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                },
                                                                "&:-webkit-autofill:focus": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                },
                                                            },
                                                        }}
                                                        name="country"
                                                        value={formik.values.country}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    >
                                                        <MenuItem value="" disabled>
                                                            Country
                                                        </MenuItem>
                                                        {country.map((type, index) => (
                                                            <MenuItem key={index} value={type}>
                                                                {type}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </Grid>

                                                <Grid size={6}>
                                                    <TextField
                                                        placeholder="zipcode"
                                                        fullWidth
                                                        variant="standard"
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                        sx={{

                                                            "& .MuiInput-root": {
                                                                borderRadius: "8px",
                                                                backgroundColor: "#FFFFFF",
                                                                height: 44,
                                                                px: 2,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                border: "1px solid #ECECEC"
                                                            },
                                                            "& .MuiInput-input": {
                                                                fontSize: 16,
                                                                fontWeight: 400,
                                                                fontFamily: "Outfit, sans-serif",
                                                                color: "#3F3F3F",
                                                                lineHeight: "100%",
                                                                "&:-webkit-autofill": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                    WebkitTextFillColor: "#3F3F3F !important",
                                                                },
                                                                "&:-webkit-autofill:hover": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                },
                                                                "&:-webkit-autofill:focus": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                },
                                                            },
                                                        }}
                                                        name="zipcode"
                                                        value={formik.values.zipcode}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.zipcode && Boolean(formik.errors.zipcode)}
                                                        helperText={formik.touched.zipcode && formik.errors.zipcode}
                                                    />

                                                </Grid>
                                            </Grid>

                                        </Typography>

                                    </Box>
                                </Box>
                            </Box>
                        </Grid>

                        {/* Right Column */}
                        <Grid size={{ xs: 12, md: 5 }}>
                            <Box
                                sx={{
                                    border: "1px solid #ECECEC",
                                    borderRadius: "4px",
                                    width: "100%",
                                    boxSizing: "border-box"
                                }}
                            >
                                {/* Project Info */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        gap: "12px",
                                        flexDirection: "column",
                                        borderBottom: "1px solid #ECECEC",
                                        p: "16px"
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: "16px",
                                            fontWeight: 500,
                                            color: "#433F5E",
                                            fontFamily: "Outfit, sans-serif"
                                        }}
                                    >
                                        Project Info
                                    </Typography>

                                    <Box
                                        sx={{
                                            display: "flex",
                                            gap: "6px",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                width: "16px",
                                                height: "16px",
                                                borderRadius: "4px",
                                                backgroundColor: "#FFFFFF",
                                            }}
                                        >
                                            <CiEdit size={14} />
                                        </Box>
                                        <Typography
                                            sx={{
                                                fontSize: "16px",
                                                fontWeight: 400,
                                                color: "#5B5772",
                                                fontFamily: "Outfit, sans-serif"
                                            }}
                                        >
                                            Edit quick information about the project
                                        </Typography>
                                    </Box>

                                    <Box
                                        sx={{
                                            display: "flex",
                                            gap: "8px",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: "16px",
                                                fontWeight: 500,
                                                color: "#5F5F5F",
                                                fontFamily: "Outfit, sans-serif"
                                            }}
                                        >
                                            Budget Info
                                        </Typography>
                                        <Box sx={{
                                            display: "flex",
                                            flexDirection: { xs: "column", md: "column", lg: "row" },
                                            gap: "15px",
                                            width: "100%"
                                        }}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "5px",
                                                    width: { xs: "100%", md: "auto" }
                                                }}
                                            >
                                                {/* Currency + Amount container */}
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        width: { xs: "100%", md: "191px" },
                                                        height: "34px",
                                                        backgroundColor: "#E7E7EB",
                                                        borderRadius: "5px",
                                                        px: "8px",
                                                        boxSizing: "border-box",
                                                    }}
                                                >
                                                    {/* Left Side - Currency Dropdown */}
                                                    <TextField
                                                        select
                                                        variant="standard"
                                                        InputProps={{ disableUnderline: true }}
                                                        name="currency_budget"
                                                        value={formik.values.currency_budget}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        sx={{
                                                            width: "55px",
                                                            "& .MuiSelect-select": {
                                                                p: 0,
                                                                fontSize: "16px",
                                                                fontWeight: 400,
                                                                color: "#0A0A0C",
                                                                letterSpacing: "1%",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                fontFamily: "Outfit, sans-serif"
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem value="INR">INR</MenuItem>
                                                        <MenuItem value="USD">USD</MenuItem>
                                                        <MenuItem value="EUR">EUR</MenuItem>
                                                    </TextField>

                                                    {/* Divider */}
                                                    <Box
                                                        sx={{
                                                            width: "1px",
                                                            height: "60%",
                                                            backgroundColor: "#C8C8C8",
                                                        }}
                                                    />

                                                    {/* Right Side - Amount Field */}
                                                    <TextField
                                                        placeholder="Budget Cost"
                                                        variant="standard"
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                        name="budgeted_cost"
                                                        value={formik.values.budgeted_cost}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        sx={{
                                                            flex: 1,
                                                            ml: "8px",
                                                            "& input": {
                                                                fontSize: "16px",
                                                                fontWeight: 400,
                                                                color: "#0A0A0C",
                                                                letterSpacing: "1%",
                                                                p: 0,
                                                                fontFamily: "Outfit",
                                                                "&:-webkit-autofill": {
                                                                    WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                                                                    WebkitTextFillColor: "#0A0A0C !important",
                                                                },
                                                                "&:-webkit-autofill:hover": {
                                                                    WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                                                                },
                                                                "&:-webkit-autofill:focus": {
                                                                    WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                                                                },
                                                            },
                                                            "& input::placeholder": {
                                                                color: "#8C8C8C",
                                                                fontFamily: "Outfit, sans-serif"
                                                            },
                                                        }}
                                                    />
                                                </Box>
                                                {formik.touched.budgeted_cost && formik.errors.budgeted_cost && (
                                                    <Typography sx={{ color: "#D92D20", fontSize: "12px", ml: 1 }}>
                                                        {formik.errors.budgeted_cost}
                                                    </Typography>
                                                )}
                                            </Box>

                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "5px",
                                                    width: { xs: "100%", md: "auto" }
                                                }}
                                            >
                                                {/* Currency + Amount container */}
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        width: { xs: "100%", md: "191px" },
                                                        height: "34px",
                                                        backgroundColor: "#E7E7EB",
                                                        borderRadius: "8px",
                                                        px: "8px",
                                                        boxSizing: "border-box",
                                                    }}
                                                >
                                                    {/* Left Side - Currency Dropdown */}
                                                    <TextField
                                                        select
                                                        variant="standard"
                                                        InputProps={{ disableUnderline: true }}
                                                        name="currency_awarded"
                                                        value={formik.values.currency_awarded}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        sx={{
                                                            width: "55px",
                                                            "& .MuiSelect-select": {
                                                                p: 0,
                                                                fontSize: "16px",
                                                                fontWeight: 400,
                                                                color: "#0A0A0C",
                                                                letterSpacing: "1%",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                fontFamily: "Outfit, sans-serif"
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem value="INR">INR</MenuItem>
                                                        <MenuItem value="USD">USD</MenuItem>
                                                        <MenuItem value="EUR">EUR</MenuItem>
                                                    </TextField>

                                                    {/* Divider */}
                                                    <Box
                                                        sx={{
                                                            width: "1px",
                                                            height: "60%",
                                                            backgroundColor: "#C8C8C8",
                                                        }}
                                                    />

                                                    {/* Right Side - Amount Field */}
                                                    <TextField
                                                        placeholder="Awarded Cost"
                                                        variant="standard"
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                        name="awarded_cost"
                                                        value={formik.values.awarded_cost}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        sx={{
                                                            flex: 1,
                                                            ml: "8px",
                                                            "& input": {
                                                                fontSize: "16px",
                                                                fontWeight: 400,
                                                                color: "#0A0A0C",
                                                                letterSpacing: "1%",
                                                                p: 0,
                                                                fontFamily: "Outfit",
                                                                "&:-webkit-autofill": {
                                                                    WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                                                                    WebkitTextFillColor: "#0A0A0C !important",
                                                                },
                                                                "&:-webkit-autofill:hover": {
                                                                    WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                                                                },
                                                                "&:-webkit-autofill:focus": {
                                                                    WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                                                                },
                                                            },
                                                            "& input::placeholder": {
                                                                color: "#8C8C8C",
                                                                fontFamily: "Outfit, sans-serif"
                                                            },
                                                        }}
                                                    />
                                                </Box>
                                                {formik.touched.awarded_cost && formik.errors.awarded_cost && (
                                                    <Typography sx={{ color: "#D92D20", fontSize: "12px", ml: 1 }}>
                                                        {formik.errors.awarded_cost}
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>

                                    <Box
                                        sx={{
                                            display: "flex",
                                            gap: "8px",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: "16px",
                                                fontWeight: 500,
                                                color: "#5F5F5F",
                                                fontFamily: "Outfit, sans-serif"
                                            }}
                                        >
                                            Original Budget Info
                                        </Typography>
                                        <Box sx={{
                                            display: "flex",
                                            flexDirection: { xs: "column", md: "column", lg: "row" },
                                            gap: "15px",
                                            width: "100%"
                                        }}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "5px",
                                                    width: { xs: "100%", md: "auto" }
                                                }}
                                            >
                                                {/* Currency + Amount container */}
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        width: { xs: "100%", md: "400px" },
                                                        height: "34px",
                                                        backgroundColor: "#E7E7EB",
                                                        borderRadius: "5px",
                                                        px: "8px",
                                                        boxSizing: "border-box",
                                                    }}
                                                >
                                                    {/* Left Side - Currency Dropdown */}
                                                    <TextField
                                                        select
                                                        variant="standard"
                                                        InputProps={{ disableUnderline: true }}
                                                        name="currency_original_budget"
                                                        value={formik.values.currency_original_budget}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        sx={{
                                                            width: "55px",
                                                            "& .MuiSelect-select": {
                                                                p: 0,
                                                                fontSize: "16px",
                                                                fontWeight: 400,
                                                                color: "#0A0A0C",
                                                                letterSpacing: "1%",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                fontFamily: "Outfit, sans-serif"
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem value="INR">INR</MenuItem>
                                                        <MenuItem value="USD">USD</MenuItem>
                                                        <MenuItem value="EUR">EUR</MenuItem>
                                                    </TextField>

                                                    {/* Divider */}
                                                    <Box
                                                        sx={{
                                                            width: "1px",
                                                            height: "60%",
                                                            backgroundColor: "#C8C8C8",
                                                        }}
                                                    />

                                                    {/* Right Side - Amount Field */}
                                                    <TextField
                                                        placeholder="Original Budgeted Cost"
                                                        variant="standard"
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                        name="original_budgeted_cost"
                                                        value={formik.values.original_budgeted_cost}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        sx={{
                                                            flex: 1,
                                                            ml: "8px",
                                                            "& input": {
                                                                fontSize: "16px",
                                                                fontWeight: 400,
                                                                color: "#0A0A0C",
                                                                letterSpacing: "1%",
                                                                p: 0,
                                                                fontFamily: "Outfit",
                                                                "&:-webkit-autofill": {
                                                                    WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                                                                    WebkitTextFillColor: "#0A0A0C !important",
                                                                },
                                                                "&:-webkit-autofill:hover": {
                                                                    WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                                                                },
                                                                "&:-webkit-autofill:focus": {
                                                                    WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                                                                },
                                                            },
                                                            "& input::placeholder": {
                                                                color: "#8C8C8C",
                                                                fontFamily: "Outfit, sans-serif"
                                                            },
                                                        }}
                                                    />
                                                </Box>
                                                {formik.touched.original_budgeted_cost && formik.errors.original_budgeted_cost && (
                                                    <Typography sx={{ color: "#D92D20", fontSize: "12px", ml: 1 }}>
                                                        {formik.errors.original_budgeted_cost}
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>

                                    <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }} >
                                        <Typography
                                            sx={{
                                                fontWeight: 500,
                                                fontSize: "16px",
                                                fontFamily: "Outfit, sans-serif",
                                                color: "#5F5F5F",
                                            }}
                                        >
                                            Project Timeline
                                        </Typography>

                                        <Box sx={{
                                            display: "flex",
                                            flexDirection: { xs: "column", md: "row" },
                                            alignItems: { md: "center", xs: "flex-start" },
                                            gap: "5px",
                                            width: "100%"
                                        }}>
                                            <Box sx={{ position: "relative", display: "inline-block" }}>
                                                <TextField
                                                    type="text"
                                                    name="start_date"
                                                    placeholder="End Date"
                                                    value={
                                                        formik.values.start_date
                                                            ? dayjs(formik.values.start_date).format("DD MMM, YYYY")
                                                            : ""
                                                    }
                                                    readOnly
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.start_date && Boolean(formik.errors.start_date)}
                                                    helperText={formik.touched.start_date && formik.errors.start_date}
                                                    FormHelperTextProps={{
                                                        style: {
                                                            visibility:
                                                                formik.touched.start_date && formik.errors.start_date
                                                                    ? "visible"
                                                                    : "hidden",
                                                        },
                                                    }}
                                                    sx={{
                                                        width: "auto",
                                                        fontWeight: 400,
                                                        fontSize: "14px",
                                                        lineHeight: "100%",
                                                        letterSpacing: "0.16px",
                                                        color: "#433F5E",
                                                        fontFamily: "Outfit, sans-serif",
                                                        "& input::-webkit-calendar-picker-indicator": {
                                                            display: "none",
                                                        },
                                                        "& input[type='text']": {
                                                            appearance: "none",
                                                            WebkitAppearance: "none",
                                                            paddingRight: "6px",
                                                        },
                                                    }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <Box
                                                                sx={{
                                                                    ml: "0px",
                                                                    mr: 1,
                                                                    color: "#433F5E",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    cursor: "pointer",
                                                                    position: "relative",
                                                                }}
                                                                onClick={handleStartIconClick}
                                                            >
                                                                <FaRegCalendarAlt style={{ fontSize: "16px" }} />

                                                                <input
                                                                    ref={startDateRef}
                                                                    type="date"
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: 0,
                                                                        left: 0,
                                                                        opacity: 0,
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    onChange={(e) => {
                                                                        const selectedDate = e.target.value
                                                                            ? dayjs(e.target.value).format("YYYY-MM-DD")
                                                                            : "";
                                                                        formik.setFieldValue("start_date", selectedDate);
                                                                    }}
                                                                />
                                                            </Box>
                                                        ),
                                                        sx: {
                                                            backgroundColor: "#E7E7EB",
                                                            height: "34px",
                                                            width: { xs: "100%", md: "145px" },
                                                            fontSize: "14px",
                                                            lineHeight: "100%",
                                                            fontWeight: 600,
                                                            letterSpacing: "0",
                                                            color: "#433F5E",
                                                            fontFamily: "Outfit, sans-serif",
                                                            borderRadius: "5px",
                                                            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                                                            "&:hover .MuiOutlinedInput-notchedOutline": { border: "none !important" },
                                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none !important" },
                                                        },
                                                    }}
                                                />
                                            </Box>
                                            <Typography
                                                sx={{
                                                    fontWeight: 500,
                                                    fontSize: "16px",
                                                    fontFamily: "Outfit, sans-serif",
                                                    lineHeight: "100%",
                                                    color: "#5F5F5FB2",
                                                    mt: { md: 0 },

                                                }}
                                            >
                                                to
                                            </Typography>
                                            <Box sx={{ position: "relative", display: "inline-block" }}>
                                                <TextField
                                                    type="text"
                                                    name="end_date"
                                                    placeholder="End Date"
                                                    value={
                                                        formik.values.end_date
                                                            ? dayjs(formik.values.end_date).format("DD MMM, YYYY")
                                                            : ""
                                                    }
                                                    readOnly
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.end_date && Boolean(formik.errors.end_date)}
                                                    helperText={formik.touched.end_date && formik.errors.end_date}
                                                    FormHelperTextProps={{
                                                        style: {
                                                            visibility:
                                                                formik.touched.end_date && formik.errors.end_date
                                                                    ? "visible"
                                                                    : "hidden",
                                                        },
                                                    }}
                                                    sx={{
                                                        width: "auto",
                                                        fontWeight: 400,
                                                        fontSize: "14px",
                                                        lineHeight: "100%",
                                                        letterSpacing: "0.16px",
                                                        color: "#433F5E",
                                                        fontFamily: "Outfit, sans-serif",
                                                        "& input::-webkit-calendar-picker-indicator": {
                                                            display: "none",
                                                        },
                                                        "& input[type='text']": {
                                                            appearance: "none",
                                                            WebkitAppearance: "none",
                                                            paddingRight: "6px",
                                                        },
                                                    }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <Box
                                                                sx={{
                                                                    ml: "0px",
                                                                    mr: 1,
                                                                    color: "#433F5E",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    cursor: "pointer",
                                                                    position: "relative",
                                                                }}
                                                                onClick={handleEndIconClick}
                                                            >
                                                                <FaRegCalendarAlt style={{ fontSize: "16px" }} />


                                                                <input
                                                                    ref={endDateRef}
                                                                    type="date"
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: 0,
                                                                        left: 0,
                                                                        opacity: 0,
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    onChange={(e) => {
                                                                        const selectedDate = e.target.value
                                                                            ? dayjs(e.target.value).format("YYYY-MM-DD")
                                                                            : "";
                                                                        formik.setFieldValue("end_date", selectedDate);
                                                                    }}
                                                                />
                                                            </Box>
                                                        ),
                                                        sx: {
                                                            backgroundColor: "#E7E7EB",
                                                            height: "34px",
                                                            width: { xs: "100%", md: "145px" },
                                                            fontSize: "14px",
                                                            lineHeight: "100%",
                                                            fontWeight: 600,
                                                            letterSpacing: "0",
                                                            color: "#433F5E",
                                                            fontFamily: "Outfit, sans-serif",
                                                            borderRadius: "5px",
                                                            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                                                            "&:hover .MuiOutlinedInput-notchedOutline": { border: "none !important" },
                                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none !important" },
                                                        },
                                                    }}
                                                />
                                            </Box>

                                        </Box>
                                    </Box>
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }} >
                                        <Typography
                                            sx={{
                                                fontWeight: 500,
                                                fontSize: "16px",
                                                fontFamily: "Outfit, sans-serif",
                                                color: "#5F5F5F",
                                            }}
                                        >
                                            Geo Location
                                        </Typography>
                                        <Box sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "7px",
                                            width: "100%",
                                            flexDirection: { xs: "column", md: "row" }
                                        }}>
                                            <TextField
                                                placeholder="Latitude"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                name="latitude"
                                                value={formik.values.latitude}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.latitude && Boolean(formik.errors.latitude)}
                                                helperText={formik.touched.latitude && formik.errors.latitude}
                                                sx={{
                                                    width: { xs: "100%", md: "145px" },
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: "8px",
                                                        backgroundColor: "#E7E7EB",
                                                        height: "34px",
                                                        border: "none",
                                                        "& input:-webkit-autofill": {
                                                            WebkitBackgroundClip: "text",
                                                            WebkitTextFillColor: "#433F5E !important",
                                                            caretColor: "#433F5E",
                                                            transition: "background-color 5000s ease-in-out 0s",
                                                        },
                                                    },
                                                    "& .MuiOutlinedInput-input": {
                                                        textAlign: "center",
                                                        color: "#433F5E",
                                                        fontFamily: "Outfit, sans-serif",
                                                        fontSize: "14px",
                                                        fontWeight: 600,
                                                        lineHeight: "100%",
                                                        fontFamily: "Outfit, sans-serif",
                                                        "&:-webkit-autofill": {
                                                            WebkitBackgroundClip: "text",
                                                            WebkitTextFillColor: "#433F5E !important",
                                                        },
                                                    },
                                                }}

                                            />

                                            <Typography
                                                sx={{
                                                    fontWeight: 500,
                                                    fontSize: "21px",
                                                    fontFamily: "Outfit",
                                                    lineHeight: "100%",
                                                    color: "#000000",
                                                }}
                                            >
                                                -
                                            </Typography>
                                            <TextField
                                                placeholder="Longitude"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                name="longitude"
                                                value={formik.values.longitude}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.longitude && Boolean(formik.errors.longitude)}
                                                helperText={formik.touched.longitude && formik.errors.longitude}
                                                sx={{
                                                    width: { xs: "100%", md: "145px" },
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: "8px",
                                                        backgroundColor: "#E7E7EB",
                                                        height: "34px",
                                                        border: "none",
                                                        "& input:-webkit-autofill": {
                                                            WebkitBackgroundClip: "text",
                                                            WebkitTextFillColor: "#433F5E !important",
                                                            caretColor: "#433F5E",
                                                            transition: "background-color 5000s ease-in-out 0s",
                                                        },
                                                    },
                                                    "& .MuiOutlinedInput-input": {
                                                        textAlign: "center",
                                                        color: "#433F5E",
                                                        fontFamily: "Outfit, sans-serif",
                                                        fontSize: "14px",
                                                        fontWeight: 600,
                                                        lineHeight: "100%",
                                                        fontFamily: "Outfit, sans-serif",
                                                        "&:-webkit-autofill": {
                                                            WebkitBackgroundClip: "text",
                                                            WebkitTextFillColor: "#433F5E !important",
                                                        },
                                                    },
                                                }}

                                            />
                                        </Box>
                                    </Box>
                                </Box>
                                {/* Contact Info */}
                                <Box sx={{ display: "flex", flexDirection: "column", gap: "14px", mt: "14px" }}>
                                    <Box sx={{ borderBottom: "1px solid #ECECEC", p: "12px 16px" }}>
                                        <Typography sx={{
                                            color: "#433F5E",
                                            fontSize: "16px",
                                            fontWeight: 500,
                                            lineHeight: "100%",
                                            fontFamily: "Outfit, sans-serif"
                                        }}>Contact Details</Typography>
                                    </Box>
                                    <Box sx={{ borderBottom: "1px solid #ECECEC", p: "0px 16px 14px 16px" }}>
                                        <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>

                                            {/* Row 1 */}
                                            <Box sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", md: "row" },
                                                alignItems: { xs: "flex-start", md: "center" },
                                                gap: { xs: "20px", md: "94px", lg: "94px" },
                                                width: "100%"
                                            }}>
                                                <Typography
                                                    sx={{
                                                        color: "#433F5E",
                                                        fontSize: "16px",
                                                        fontWeight: 400,
                                                        lineHeight: "100%",
                                                        fontFamily: "Outfit, sans-serif",
                                                        width: { xs: "100%", md: "150px" }
                                                    }}
                                                >
                                                    Project Admin
                                                </Typography>

                                                <Box sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "5px",
                                                    width: { xs: "100%", md: "auto" }
                                                }}>
                                                    <Box
                                                        sx={{
                                                            backgroundColor: "#433F5E",
                                                            borderRadius: "50px",
                                                            height: "32px",
                                                            width: "32px",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <Avatar
                                                            src=""
                                                            alt=""
                                                            sx={{
                                                                height: "16px",
                                                                width: "16px",
                                                            }}
                                                        />
                                                    </Box>

                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: "2px",
                                                            justifyContent: "flex-start",
                                                        }}
                                                    >
                                                        <TextField
                                                            placeholder="Project Manager Name"
                                                            variant="standard"
                                                            inputRef={inputRef}
                                                            InputProps={{ disableUnderline: true, readOnly: !isEditable, }}
                                                            name="project_manager_name"
                                                            value={formik.values.project_manager_name}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            sx={{
                                                                "& .MuiInput-root": {
                                                                    backgroundColor: "transparent",
                                                                    height: "auto",
                                                                    px: 0,
                                                                },
                                                                "& .MuiInput-input": {
                                                                    color: "#433F5E",
                                                                    fontSize: "16px",
                                                                    fontWeight: 400,
                                                                    lineHeight: "100%",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    padding: 0,
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                        WebkitTextFillColor: "#433F5E !important",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                    },
                                                                },
                                                            }}
                                                        />

                                                        <Button
                                                            disableRipple
                                                            disableElevation
                                                            onClick={handleEditClick}
                                                            sx={{
                                                                color: "#0A65E4",
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: "100%",
                                                                fontFamily: "Outfit, sans-serif",
                                                                p: 0,
                                                                minWidth: "auto",
                                                                justifyContent: "flex-start",
                                                                textTransform: "none",
                                                                backgroundColor: "transparent",
                                                                "&:hover": {
                                                                    backgroundColor: "transparent",
                                                                },
                                                            }}
                                                        >
                                                            Change Admin
                                                        </Button>
                                                    </Box>
                                                </Box>
                                            </Box>

                                            {/* Row 2 */}
                                            <Box sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: { xs: "30px", md: "94px", lg: "94px" },
                                                flexDirection: { xs: "column", md: "row" },
                                                alignItems: { xs: "flex-start", md: "center" }
                                            }}>
                                                <Typography
                                                    sx={{
                                                        color: "#433F5E",
                                                        fontSize: "16px",
                                                        fontWeight: 400,
                                                        lineHeight: "100%",
                                                        fontFamily: "Outfit, sans-serif",
                                                        width: { xs: "100%", md: "150px" }
                                                    }}
                                                >
                                                    Designation
                                                </Typography>

                                                <Box sx={{ display: "flex", flexDirection: "column", }}>
                                                    <TextField
                                                        placeholder="Designation"
                                                        variant="standard"
                                                        InputProps={{ disableUnderline: true }}
                                                        name="project_manager_designation"
                                                        value={formik.values.project_manager_designation}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        sx={{
                                                            "& .MuiInput-root": {
                                                                backgroundColor: "transparent",
                                                                height: "auto",
                                                                px: 0,
                                                            },
                                                            "& .MuiInput-input": {
                                                                color: "#433F5E",
                                                                fontSize: "16px",
                                                                fontWeight: 400,
                                                                lineHeight: "100%",
                                                                fontFamily: "Outfit, sans-serif",
                                                                padding: 0,
                                                                "&:-webkit-autofill": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                    WebkitTextFillColor: "#433F5E !important",
                                                                },
                                                                "&:-webkit-autofill:hover": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                },
                                                                "&:-webkit-autofill:focus": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {formik.touched.project_manager_designation && formik.errors.project_manager_designation && (
                                                        <Typography sx={{ color: "#D92D20", fontSize: "12px", mt: 0.5 }}>
                                                            {formik.errors.project_manager_designation}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </Box>
                                            <Box sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: { xs: "30px", md: "60px", lg: "94px" },
                                                flexDirection: { xs: "column", md: "row" },
                                                alignItems: { xs: "flex-start", md: "center" }
                                            }}>
                                                <Typography
                                                    sx={{
                                                        color: "#433F5E",
                                                        fontSize: "16px",
                                                        fontWeight: 400,
                                                        lineHeight: "100%",
                                                        fontFamily: "Outfit, sans-serif",
                                                        width: { xs: "100%", md: "150px" }
                                                    }}
                                                >
                                                    Work Email
                                                </Typography>

                                                <Box sx={{ display: "flex", flexDirection: "column", }}>
                                                    <TextField
                                                        placeholder="Work Email"
                                                        variant="standard"
                                                        InputProps={{ disableUnderline: true }}
                                                        name="project_manager_email"
                                                        value={formik.values.project_manager_email}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        sx={{
                                                            "& .MuiInput-root": {
                                                                backgroundColor: "transparent",
                                                                height: "auto",
                                                                px: 0,
                                                            },
                                                            "& .MuiInput-input": {
                                                                color: "#433F5E",
                                                                fontSize: "16px",
                                                                fontWeight: 400,
                                                                lineHeight: "100%",
                                                                fontFamily: "Outfit, sans-serif",
                                                                padding: 0,
                                                                "&:-webkit-autofill": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                    WebkitTextFillColor: "#433F5E !important",
                                                                },
                                                                "&:-webkit-autofill:hover": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                },
                                                                "&:-webkit-autofill:focus": {
                                                                    WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {formik.touched.project_manager_email && formik.errors.project_manager_email && (
                                                        <Typography sx={{ color: "#D92D20", fontSize: "12px", mt: 0.5 }}>
                                                            {formik.errors.project_manager_email}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </Box>
                                            <Box sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: { xs: "30px", md: "60px", lg: "94px" },
                                                flexDirection: { xs: "column", md: "row" },
                                                alignItems: { xs: "flex-start", md: "center" }
                                            }}>
                                                <Typography
                                                    sx={{
                                                        color: "#433F5E",
                                                        fontSize: "16px",
                                                        fontWeight: 400,
                                                        lineHeight: "100%",
                                                        fontFamily: "Outfit, sans-serif",
                                                        width: { xs: "100%", md: "150px" }
                                                    }}
                                                >
                                                    Phone Number
                                                </Typography>
                                                <Box sx={{ display: "flex", flexDirection: "column", }}>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            width: { xs: "100%", md: "auto" },
                                                            height: "34px",
                                                            backgroundColor: "#E7E7EB",
                                                            borderRadius: "5px",
                                                            px: "6px",
                                                            boxSizing: "border-box",
                                                            overflow: "hidden"
                                                        }}
                                                    >
                                                        {/* Left Side - Currency Dropdown */}
                                                        <TextField
                                                            select
                                                            variant="standard"
                                                            InputProps={{ disableUnderline: true }}
                                                            name="country_code"
                                                            value={formik.values.country_code}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            sx={{
                                                                width: "55px",
                                                                "& .MuiSelect-select": {
                                                                    p: 0,
                                                                    fontSize: "16px",
                                                                    fontWeight: 400,
                                                                    color: "#0A0A0C",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    fontFamily: "Outfit, sans-serif"
                                                                },
                                                            }}
                                                        >{
                                                                phoneCodes.map((item, ind) => (
                                                                    <MenuItem key={ind} value={item}>
                                                                        {item}
                                                                    </MenuItem>

                                                                ))
                                                            }
                                                        </TextField>

                                                        {/* Divider line between dropdown and textfield */}
                                                        <Box
                                                            sx={{
                                                                width: "1px",
                                                                height: "60%",
                                                                backgroundColor: "#C8C8C8",
                                                            }}
                                                        />

                                                        {/* Right Side - Text Input */}
                                                        <TextField
                                                            placeholder="Phone Number"
                                                            variant="standard"
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                            name="project_manager_phoneno"
                                                            value={formik.values.project_manager_phoneno}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            error={formik.touched.project_manager_phoneno && Boolean(formik.errors.project_manager_phoneno)}

                                                            sx={{
                                                                flex: 1,
                                                                ml: "8px",
                                                                "& input": {
                                                                    fontSize: "16px",
                                                                    fontWeight: 400,
                                                                    color: "#0A0A0C",
                                                                    p: 0,
                                                                    fontFamily: "Outfit",
                                                                    "&:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                                                                        WebkitTextFillColor: "#0A0A0C !important",
                                                                    },
                                                                    "&:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                                                                    },
                                                                    "&:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 100px #E7E7EB  inset !important",
                                                                    },
                                                                },
                                                                "& input::placeholder": {
                                                                    color: "#8C8C8C",
                                                                    fontFamily: "Outfit, sans-serif"
                                                                },
                                                            }}
                                                        />
                                                    </Box>
                                                    {formik.touched.project_manager_phoneno && formik.errors.project_manager_phoneno && (
                                                        <Typography sx={{ color: "#D92D20", fontSize: "12px", mt: 0.5 }}>
                                                            {formik.errors.project_manager_phoneno}
                                                        </Typography>
                                                    )}
                                                </Box>

                                            </Box>

                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                            <Box sx={{
                                mt: "12px",
                                border: "1px solid #ECECEC",
                                p: "16px",
                                borderRadius: "4px",
                                width: "100%",
                                boxSizing: "border-box"
                            }}>
                                <Box sx={{ display: "flex", flexDirection: "column", gap: "12px", justifyContent: "flex-start" }}>
                                    <Typography sx={{
                                        fontSize: "16px",
                                        fontWeight: 500,
                                        color: "#433F5E",
                                        fontFamily: "Outfit, sans-serif",
                                        lineHeight: "100%"
                                    }}>
                                        Project icon
                                    </Typography>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: { xs: "flex-start", md: "center" },
                                            gap: { xs: "12px", md: "16px" },
                                            mt: "12px",
                                            flexDirection: { xs: "column", md: "row" },
                                            borderRadius: "8px",
                                            border: "none",
                                            width: "100%",
                                            height: { xs: "auto", md: "100px" },
                                            p: { xs: "16px", md: "0px" },
                                            backgroundColor: "#FFFFFF",
                                            boxSizing: "border-box",
                                        }}
                                    >

                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: { xs: "flex-start", md: "center" },
                                                width: { xs: "100%", md: "90px" },
                                                height: { xs: "60px", md: "100%" },
                                                minHeight: { xs: "60px", md: "100%" },
                                                backgroundColor: "#F5F5F5",
                                                borderRadius: { xs: "6px", md: "0px" },
                                                p: "4px 9px",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: { xs: 50, sm: 58 },
                                                    height: { xs: 38, sm: 58 },
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                {formik.values.projectIcon && (
                                                    <img
                                                        src={
                                                            iconList.find((icon) => icon.name === formik.values.projectIcon)?.src
                                                        }
                                                        alt="icon"
                                                        width="58"
                                                        height="58"
                                                    />
                                                )}
                                            </Box>
                                        </Box>

                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                                width: "100%",
                                                p: { xs: "0px", md: "16px 16px 16px 0px" },
                                                boxSizing: "border-box",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: { xs: "100%", md: "auto" },
                                                    height: "15px",
                                                    borderRadius: "5px",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    backgroundColor: "#FFFFFF",
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontWeight: 400,
                                                        fontSize: "12px",
                                                        fontFamily: "Outfit, sans-serif",
                                                        color: "#0A65E4",
                                                        lineHeight: "100%"
                                                    }}
                                                >
                                                    Select a Project Icon
                                                </Typography>
                                            </Box>

                                            <Box
                                                sx={{
                                                    display: "grid",
                                                    gridTemplateColumns: {
                                                        xs: "repeat(4, 1fr)",
                                                        sm: "repeat(6, 1fr)",
                                                        md: "repeat(9, 1fr)",
                                                    },
                                                    gap: { xs: "10px", sm: "15px" },
                                                    mt: "13px",
                                                    width: "100%",
                                                    backgroundColor: "#FFFFFF",
                                                    border: "none",
                                                }}
                                            >
                                                {iconList.map(({ name, src }, index) => (
                                                    <IconButton
                                                        key={index}
                                                        onClick={() => formik.setFieldValue("projectIcon", name)}
                                                        sx={{
                                                            width: 30,
                                                            height: 30,
                                                            backgroundColor:
                                                                formik.values.projectIcon === name ? "#E3F2FD" : "#F5F5F5",
                                                            borderRadius: "4px",
                                                            "&:hover": {
                                                                backgroundColor:
                                                                    formik.values.projectIcon === name ? "#E3F2FD" : "#E0E0E0",
                                                            },
                                                        }}
                                                    >
                                                        <img src={src} alt={name} width="20" height="20" />
                                                    </IconButton>
                                                ))}
                                            </Box>
                                        </Box>

                                    </Box>
                                </Box>

                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    width: "100%",
                                    mt: "10px",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: { xs: "100%", md: "302px" },
                                        height: "48px",
                                        borderRadius: "3px",
                                        backgroundColor: "#00344C",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Button
                                        type="submit"
                                        sx={{
                                            fontWeight: 500,
                                            fontSize: "16px",
                                            lineHeight: "16px",
                                            letterSpacing: "1%",
                                            color: "#FFFFFF",
                                            height: "100%",
                                            fontFamily: "Outfit, sans-serif",
                                            textTransform: "none",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "100%",
                                        }}
                                    >
                                        Save Changes
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default EditProject;
